"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _mapActions = require("../actions/mapActions");

var _Button = _interopRequireDefault(require("./Button"));

var _map = _interopRequireDefault(require("../config/map"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ZoomToPointButton = function ZoomToPointButton(props) {
  var dispatch = (0, _reactRedux.useDispatch)();
  var currentView = (0, _reactRedux.useSelector)(function (state) {
    return state.mapViewReducer.mapView;
  });

  var navToPoint = function navToPoint() {
    dispatch((0, _mapActions.navigateToPoint)(props));
  };

  return /*#__PURE__*/_react.default.createElement(_Button.default, {
    title: 'Magnify/Zoom',
    disabled: currentView.zoom === _map.default.maxZoom,
    classNames: ['infobox-buttons'],
    onClick: navToPoint
  }, "Magnify/Zoom");
};

ZoomToPointButton.propTypes = {
  lat: _propTypes.default.number.isRequired,
  lng: _propTypes.default.number.isRequired
};
var _default = ZoomToPointButton;
exports.default = _default;